import React, { PureComponent } from "react";
import { branch } from "baobab-react/higher-order";
import PropTypes from "baobab-react/prop-types";
import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";
import {
	Button,
	Dropdown,
	MenuItem
} from "react-bootstrap";
import autoBind from "react-autobind";
import _ from "lodash";

//import globals from "../../constants/env";
//import * as s3Actions from "../../persistence/s3";
//import { showError, showYesNo, showConfirm } from "../../actions/alertActions";
import { showConfirm, showError } from "../../actions/alertActions";
//import { isMobile, generateUUID, getExtension, isVideo, dataURItoBlob } from "../../utils/utils";
import { generateUUID, getExtension, dataURItoBlob, isVideo } from "../../utils/utils";
import { markdownToHtml } from "../../utils/markupUtils";
//import { waitForKeyExists } from "../../persistence/s3";
//import * as actions from "../../actions/actions";
import * as playerActions from "../../actions/playerActions";
import historyActions from "../../actions/historyActions";
import Loader from "../shared/loader";
import CameraModal from "../camera/cameraModal";
import ambifi from "../../ambifi";

class MediaAttachments extends PureComponent {
	constructor(props) {
		super(props);
		autoBind(this);

		this.state = {
			progressVisible: false,
			progressPercent: 0,
			cameraMode: "image",
			showSpinner: false
		};
	}

	addMedia(image) {
		const selectedItem = this.context.tree.get(["activity", "children", this.props.listIndex, "children", this.props.sectionIndex, "children", this.props.itemIndex]);

		let newImages;
		if (!selectedItem.hasOwnProperty("mediaAttachments") || selectedItem.mediaAttachments === null) {
			newImages = [];
		} else {
			newImages = selectedItem.mediaAttachments;
		}

		let newImagesUrls;
		if (!selectedItem.hasOwnProperty("mediaAttachmentsUrls") || selectedItem.mediaAttachmentsUrls === null) {
			newImagesUrls = [];
		} else {
			newImagesUrls = selectedItem.mediaAttachmentsUrls;
		}

		// Store a flag if uploaded properly
		newImages.push(image);
		newImagesUrls.push(image.remoteUri);

		this.props.dispatch(playerActions.handleChangePropertyDisconnected, this.props.listIndex, this.props.sectionIndex, this.props.itemIndex, "mediaAttachments", newImages);
		this.props.dispatch(playerActions.handleChangePropertyDisconnected, this.props.listIndex, this.props.sectionIndex, this.props.itemIndex, "mediaAttachmentsUrls", newImagesUrls);

		// Update history
		historyActions.setMediaAttachment(this.context.tree, this.props.listIndex + "," + this.props.sectionIndex + "," + this.props.itemIndex, image.remoteUri, this.props.user.identityId);

		this.forceUpdate();
	}

	updateMedia(image, imageUrl, imageId, uploaded) {
		const selectedItem = this.context.tree.get(["activity", "children", this.props.listIndex, "children", this.props.sectionIndex, "children", this.props.itemIndex]);

		let newImages;
		if (selectedItem.mediaAttachments === null) {
			newImages = [];
		} else {
			newImages = selectedItem.mediaAttachments;
		}

		/*
		let newImagesUrls = [];
		if (selectedItem.mediaAttachmentsUrls === null) {
			newImagesUrls = [];
		} else {
			newImagesUrls = selectedItem.mediaAttachmentsUrls;
		}
		*/

		// Find image object to replace
		let imageItem = _.find(newImages, ["imageId", imageId]);
		imageItem.uploaded = uploaded;

		this.props.dispatch(playerActions.handleChangeProperty, this.props.listIndex, this.props.sectionIndex, this.props.itemIndex, "value", newImages);

		this.forceUpdate();
	}

	renderMediaAttachments(mediaAttachmentsUrls) {

		let mediaAttachmentsHtml = "";
		for (let i = 0; i < mediaAttachmentsUrls.length; i++) {

			let url = mediaAttachmentsUrls[i];
			let mediaAttachment = "";
			if (url !== null) {
				let ext = getExtension(url);

				if (ext === "mp4" || ext === "mov" || ext === "avi") {
					mediaAttachment = "<p><b>Video Thumbnail</b><br/><a href='" + url.replace("." + ext, ".mp4") + "' target='blank'><img src='" + url.replace("." + ext, "-00001.png") + "' /></a></p>";
				} else {
					mediaAttachment = "<p><b>Photo</b><br/><a href='" + url + "' target='blank'><img style='width: 50%' src='" + url + "' /></a></p>";
				}
			}

			mediaAttachmentsHtml += mediaAttachment;
		}

		return <div style={{ display: "flex", flex: 1, width: "100%", margin: 10, overflowY: "auto" }}>
			<div style={{ display: "flex", flexDirection: "column", width: "100%" }} dangerouslySetInnerHTML={markdownToHtml(mediaAttachmentsHtml)} />
		</div>;
	}

	showHideCameraModal(show, cameraMode) {
		this.setState({
			showCameraModal: show,
			cameraMode: cameraMode
		});
	}

	onCameraAccept(event) {
		const self = this;
		this.showHideCameraModal(false, this.state.cameraMode);

		let fileData;
		let fileName;
		let fileType;
		if (event.type === "video") {
			fileType = "video/mp4";
			fileData = event.blob;
			fileName = "video-capture-" + generateUUID() + ".mp4";
		} else {
			fileType = "image/png";
			fileData = dataURItoBlob(event.data, fileType);
			fileName = "screeshot-" + generateUUID() + ".png";
		}

		this.showSpinner();

		this.importMediaFile({
			fileName: fileName,
			fileType: fileType,
			fileData: fileData
		}).then((value) => {
			self.addMedia(value);
			self.hideSpinner();
		});
	}

	handleClickUpload(id) {
		document.getElementById(id).click();
	}

	uploadFile(event) {
		const self = this;
		// console.log("UPLOAD FILE!!!");
		if (event.target && event.target.files && event.target.files.length === 0) {
			return;
		}

		let file = event.target.files[0];

		this.showSpinner();

		this.importMediaFile({
			fileName: file.name,
			fileSize: file.size,
			fileType: file.type,
			fileData: file
		}).then((value) => {
			self.addMedia(value);
			self.hideSpinner();
		});
	}


	showSpinner() {
		this.setState({ showSpinner: true });
	}

	hideSpinner() {
		this.setState({ showSpinner: false });
	}

	importMediaFile(params) {
		//// console.log("PARAMS", params);
		const self = this;

		return new Promise((resolve, reject) => {
			let fileName = generateUUID();

			let ext = getExtension(params.fileName);
			// let newExt;

			const targetType = isVideo(params.fileName) ? "video" : "image";

			let value = {
				fileName: params.fileName,
				fileSize: params.size,
				fileType: params.type,
				uploaded: true,
				imageId: fileName
			};
			// console.log("Handling upload", value, ext, targetType);

			ambifi.persistenceManager.uploadMediaFile(params.fileData, fileName + "." + ext, targetType, this.props.identityId).then((res) => {
				self.hideSpinner();
				value.remoteUri = res.url;
				resolve(value);
			}).catch((err) => {
				self.hideSpinner();
				reject(err);
				showError("Upload Media Asset", "Failed to upload media asset, please make sure you have proper connectivity.");
			});
		});
	}

	render() {
		let self = this;

		const selectedItem = self.context.tree.get(["activity", "children", this.props.listIndex, "children", this.props.sectionIndex, "children", this.props.itemIndex]);

		let cameraModal = <CameraModal isOpen={this.state.showCameraModal} onClose={(e) => this.showHideCameraModal(false, this.state.cameraMode)}
			onAccept={this.onCameraAccept} title={(this.state.cameraMode === "image") ? "Take Photo ..." : "Capture video ..."} mode={this.state.cameraMode} showModeSelector={false} />;

		let imageMediaAttachmentId = "imageMediaAttachment" + selectedItem.guid;
		let videoMediaAttachmentId = "videoMediaAttachment" + selectedItem.guid;

		return (
			<div style={{ display: "flex", flex: 1, backgroundColor: "white", flexDirection: "column", padding: 10 }}>
				<div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
					<div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
						<Dropdown>
							<Dropdown.Toggle>
								Add Photo
							</Dropdown.Toggle>
							<Dropdown.Menu>
								<MenuItem eventKey="1" onClick={(e) => { this.showHideCameraModal(true, "image"); }}>
									<label style={{ fontWeight: "normal" }}>
										<FontAwesomeIcon icon={["fas", "camera"]} /> Take Photo ...
									</label>
								</MenuItem>
								<MenuItem eventKey="2" onClick={() => { this.handleClickUpload(imageMediaAttachmentId); }}>
									<label style={{ fontWeight: "normal", width: "100%" }} onChange={this.uploadFile}>
										<FontAwesomeIcon icon={["fas", "upload"]} /> Upload file ... <input key={imageMediaAttachmentId} type="file" accept={"image/*"} id={imageMediaAttachmentId} style={{ display: "none" }} onClick={(e) => e.stopPropagation()} />
									</label>
								</MenuItem>
							</Dropdown.Menu>
						</Dropdown>
						<div style={{ width: 10 }} />
						<Dropdown>
							<Dropdown.Toggle>
								Add Video
							</Dropdown.Toggle>
							<Dropdown.Menu>
								<MenuItem eventKey="1" onClick={(e) => { this.showHideCameraModal(true, "video"); }}>
									<label style={{ fontWeight: "normal" }}>
										<FontAwesomeIcon icon={["fas", "camera"]} /> Capture Video ...
									</label>
								</MenuItem>
								<MenuItem eventKey="2" onClick={() => { this.handleClickUpload(videoMediaAttachmentId); }}>
									<label style={{ fontWeight: "normal", width: "100%" }} onChange={this.uploadFile}>
										<FontAwesomeIcon icon={["fas", "upload"]} /> Upload file ... <input key={videoMediaAttachmentId} type="file" accept={"video/*"} id={videoMediaAttachmentId} style={{ display: "none" }} onClick={(e) => e.stopPropagation()} />
									</label>
								</MenuItem>
							</Dropdown.Menu>
						</Dropdown>
					</div>
					<Button
						onClick={(e) => {
							showConfirm("Are you sure you want to delete all media?", "Delete All Media", () => {
								self.props.dispatch(playerActions.handleChangeProperty, self.props.listIndex, self.props.sectionIndex, self.props.itemIndex, "mediaAttachments", []);
								self.props.dispatch(playerActions.handleChangeProperty, self.props.listIndex, self.props.sectionIndex, self.props.itemIndex, "mediaAttachmentsUrls", []);

								// Clear history
								for (let i = 0; i < selectedItem.mediaAttachmentsUrls; i++) {
									let mediaAttachmentsUrl = selectedItem.mediaAttachmentsUrls[i];
									historyActions.clearMediaAttachment(this.context.tree, this.props.listIndex + "," + this.props.sectionIndex + "," + this.props.itemIndex, mediaAttachmentsUrl, self.props.user.indentityId);
								}
								self.forceUpdate();
							});
						}}>Delete All Media</Button>
				</div>
				{(!selectedItem.hasOwnProperty("mediaAttachments") || selectedItem.mediaAttachments === null || selectedItem.mediaAttachments.length === 0) ? <div style={{ flex: 1, alignItems: "center", justifyContent: "center" }}><div style={{ marginTop: 25 }}>No media has been added.</div></div> : null}
				{(selectedItem.mediaAttachments && selectedItem.mediaAttachments.length > 0) ? this.renderMediaAttachments(selectedItem.mediaAttachmentsUrls) : null}
				{cameraModal}
				<Loader fullPage show={this.state.showSpinner} />
			</div>
		);
	}
}

MediaAttachments.contextTypes = {
	tree: PropTypes.baobab
};

export default branch({
	dimensions: ["dimensions"],
	user: ["user"]
}, MediaAttachments);


